// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__MCGNl","infected":"Cards_infected__3IWKA","recovered":"Cards_recovered__1cZww","deaths":"Cards_deaths__13Bi4"};